export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatGBP = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n);

export const IMAGES = {
  feature1: "https://images.pexels.com/photos/39368199/pexels-photo-39368199.jpeg",
  feature2: "https://images.pexels.com/photos/28772725/pexels-photo-28772725.jpeg",
  feature3: "https://images.pexels.com/photos/15774577/pexels-photo-15774577.jpeg",
  feature4: "https://images.pexels.com/photos/7820326/pexels-photo-7820326.jpeg",
  fullBleed: "https://images.unsplash.com/photo-1721592873149-9823d9dc6b40",
  proof: "https://images.pexels.com/photos/7577374/pexels-photo-7577374.jpeg",
};
